// extracted by mini-css-extract-plugin
export default {"page":"ej-z","cartModal":"fj-z","checkout":"gj-z","placeholder":"hj-z","account":"ij-z"};